(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('painelEdicaoAplicacao', {
      controller: 'PainelEdicaoAplicacaoCtrl',
      templateUrl: 'views/propriedade/edit-aplicacao.html',
      bindings: {
        application: '<data'
      }
    });
}());
